import { defaultProfilePicFileName, getProfilePicPath } from "../../constants/instructorConstants";
import { getApiUrl } from "../../constants/pathConstants"
import { communityStateData } from "../../data/communityStateData"
import { UserFollowerData, UserPost } from "../../types/posts";
import { API_END_POINT_FOLLOW_USER, API_END_POINT_GET_DATA_FOR_USER, API_END_POINT_GET_FOLLOW_USERS, API_END_POINT_GET_POSTS_FOR_USER, API_END_POINT_GET_USER_FOLLOWS, API_END_POINT_UNFOLLOW_USER } from "../endPoints";
import { UserData } from "../types";
// import { UserDetails } from "../types";

class UserConnector {
	requestInProgress: boolean = false

	public async getUserDataRequest(userId: string): Promise<UserData | undefined> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [UserConnector] getUserDataRequest() called while request is in process')
				this.requestInProgress = false
				return undefined
			} else {
				this.requestInProgress = true
				const urlParams = new URLSearchParams()
				urlParams.append("id", userId)
				urlParams.append("cache", `${Math.random()}`) // userId)

				let headers = new Headers();

				headers.append('Content-Type', 'application/json');
				headers.append('Accept', 'application/json');

				let newUserData: UserData = {
					id: userId,
					email: '',
					status: '',
					name: 'User',
					phone: '',
					interactions: '',
					about_text: '',
					hero_pic: '',
					profile_pics: ''
				}

				await fetch(`${getApiUrl()}${API_END_POINT_GET_DATA_FOR_USER}?${urlParams}`, {
					method: 'GET',
					headers: headers
				})
					.then((res) => res.json())
					.then((data) => {
						// console.log(data)
						if (data.userData) {
							console.log(data.userData)
							// const userDataArr: UserData[] = data.userData as UserData[]
							newUserData.name = data.userData[0].name
							newUserData.about_text = data.userData[0].about_text
							newUserData.hero_pic = data.userData[0].hero_pic
							newUserData.profile_pics = data.userData[0].profile_pics
							
							// this.requestInProgress = false
							// console.log('newUserData = ', newUserData)
							// return newUserData
						} else {
							// TODO: add error handling for searches which don't return values
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return newUserData
				// return undefined
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[UserConnector] - getUserDataRequest() failed')
			console.log(err)
			return undefined
		}
	}

	public async getFollowUsersDataRequest(userId: string): Promise<UserFollowerData[]> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [UserConnector] getUserFollowDataRequest() called while request is in process')
				this.requestInProgress = false
				return []
			} else {
				this.requestInProgress = true
				const urlParams = new URLSearchParams()
				urlParams.append("id", userId)
				urlParams.append("cache", `${Math.random()}`) // userId)

				let headers = new Headers();

				headers.append('Content-Type', 'application/json');
				headers.append('Accept', 'application/json');

				let followData: UserFollowerData[] = []

				await fetch(`${getApiUrl()}${API_END_POINT_GET_FOLLOW_USERS}?${urlParams}`, {
					method: 'GET',
					headers: headers
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.userData) {
							followData = data.userData as UserFollowerData[]
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return followData
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[UserConnector] - getUserFollowDataRequest() failed')
			console.log(err)
			return []
		}
	}

	public async getUserFollowDataRequest(userId: string): Promise<UserFollowerData[]> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [UserConnector] getUserFollowDataRequest() called while request is in process')
				this.requestInProgress = false
				return []
			} else {
				this.requestInProgress = true
				const urlParams = new URLSearchParams()
				urlParams.append("id", userId)
				urlParams.append("cache", `${Math.random()}`) // userId)

				let headers = new Headers();

				headers.append('Content-Type', 'application/json');
				headers.append('Accept', 'application/json');

				let followData: UserFollowerData[] = []

				await fetch(`${getApiUrl()}${API_END_POINT_GET_USER_FOLLOWS}?${urlParams}`, {
					method: 'GET',
					headers: headers
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.userData) {
							followData = data.userData as UserFollowerData[]
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return followData
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[UserConnector] - getUserFollowDataRequest() failed')
			console.log(err)
			return []
		}
	}

	public async followUserRequest(follow_id: string, user_id: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [UserConnector] followUserRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				let requestSuccess = false

				await fetch(`${getApiUrl()}${API_END_POINT_FOLLOW_USER}`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"follow_id": follow_id,
						"user_id": user_id
					})
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.status === 'success') {
							requestSuccess = true
						} else {
							requestSuccess = false
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return requestSuccess
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[UserConnector] - followUserRequest() failed')
			console.log(err)
			return false
		}
	}

	public async unfollowUserRequest(follow_id: string, user_id: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [UserConnector] unfollowUserRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				let requestSuccess = false

				await fetch(`${getApiUrl()}${API_END_POINT_UNFOLLOW_USER}`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"follow_id": follow_id,
						"user_id": user_id
					})
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.status === 'success') {
							requestSuccess = true
						} else {
							requestSuccess = false
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return requestSuccess
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[UserConnector] - unfollowUserRequest() failed')
			console.log(err)
			return false
		}
	}
}

export const userConnector: UserConnector = new UserConnector()